{
  "admin": {
    "fast-forward": "Fast-forward",
    "no-segment-pause": "Don't stop at segments",
    "show-correct-answers": "Show the correct answers",
    "title": "Test Mode",
    "transfer-to-new-device": "Transfer to a new device",
    "video-stats": "Show video stats"
  },
  "android-app": {
    "download-button": "Get it on Google Play",
    "footer-note": "Can't find where to enter the code? After opening the app, you'll see the \"Employee Login\" screen.",
    "heading": "Install the app and sign in with your code",
    "how-to-start": "How to get started:",
    "intro": "What you get:",
    "notifications-desc": "Get real-time notifications without having to check the app manually.",
    "notifications-title": "Instant notifications (Push Notifications)",
    "scanner-desc": "The smart camera automatically detects the document edges, corrects perspective, and optimizes lighting for better text readability.",
    "scanner-title": "Advanced document scanner",
    "step1": "Download the app:",
    "step2": "Open it",
    "step3": "Enter the following code:",
    "title": "Android App"
  },
  "broadcast": {
    "from": "Sent from <Name/> at <SentAt/>",
    "mark-as-read": "Mark as read",
    "mark-as-read-confirm": {
      "title": "Sign to confirm that you have read and understood this message"
    },
    "read-at": "Read by <Name/> at <ReadAt/>"
  },
  "control-card": {
    "action": {
      "complete": "Complete the card",
      "print": "Print",
      "signature": "Signature",
      "title": "Control card actions",
      "uncomplete": "Unlock the card",
      "view-print": "View / Print"
    },
    "add-new-record-title": "Add new record in {{title}}",
    "breadcrumbs": {
      "row": "Record {{current}} of {{total}}"
    },
    "comment": "Comment",
    "complete-alert": {
      "confirm": "Complete",
      "message": "To complete the control card, you must fill in all entries.",
      "title_one": "There is one entry that is not completed",
      "title_other": "There are {{count}} entries that are not completed"
    },
    "complete-error": {
      "message_one": "There is one record that has to be filled in",
      "message_other": "There are {{count}} records that have to be filled in",
      "title": "The control card cannot be completed"
    },
    "due-to": "due to: <Time/><RelTime/>",
    "error": {
      "saving-error": "An error occurred while saving the data: {{message}}. To try again, press the \"Save\" button"
    },
    "instantiate": {
      "confirmation-message": "Are you sure you want to create a \"{{name}}\" control card?",
      "header": "New Control Card \"{{name}}\"",
      "message": "You can choose one of the following options:",
      "option-create-copy": "Transfer data from this control card",
      "option-create-empty": "New empty control card"
    },
    "location": {
      "archived-title": "Archived control cards",
      "create-new": "Create",
      "date": "Date",
      "edit-disabled-banner": "The card cannot be edited due to expiration or lack of permissions for completion.",
      "label": "Location",
      "no-control-cards": "There are no control cards matching the filter",
      "not-applicable": {
        "header": "Not Applicable",
        "message": "This control card is marked as not applicable by {{notApplicableBy}} with the following reason: {{notApplicableReason}}"
      },
      "recurring": {
        "create": {
          "date": "Date",
          "no-permission": "You don't have permission to create control cards for this date",
          "template": "Select a control card",
          "title": "New Control Card"
        },
        "filter": {
          "endDate": "Until",
          "label": "Filter",
          "startDate": "From",
          "status": "Status",
          "statuses": {
            "all": "Completed and not completed",
            "complete": "Completed",
            "incomplete": "Not completed"
          },
          "subtitle": "Filter the control cards by the following criteria",
          "template": "Type",
          "text": "Name",
          "textPlaceholder": "Type to search by name",
          "title": "Control Cards To Fill In"
        },
        "load-more": "Load more before <StartDate/>"
      },
      "title": "Control Cards To Fill In"
    },
    "nested": {
      "create": "Create",
      "creating": "Creating...",
      "open": "Open",
      "status": {
        "completed": "Completed",
        "not-applicable": "Not applicable",
        "pending": "Not completed"
      }
    },
    "no-locations": "You don't have access to the control cards in any location",
    "number-range": {
      "max-exceeded": "The value must be less than {{maxValue}}",
      "min-exceeded": "The value must be greater than {{minValue}}",
      "no-unit": {
        "closed": "{{start}} – {{end}}",
        "open-end": "above {{start}}",
        "open-start": "below {{end}}"
      },
      "text": "Range",
      "unit": {
        "closed": "{{start}} – {{end}} {{unit}}",
        "open-end": "above {{start}} {{unit}}",
        "open-start": "below {{end}} {{unit}}"
      }
    },
    "override-validation-result": {
      "mark-not-applicable": "Mark as not applicable",
      "option": {
        "not-applicable": "Not applicable",
        "other": "Other",
        "other-placeholder": "Enter reason"
      },
      "reason-option-required": "You must select one of the following options:",
      "title": "Provide a reason why you cannot fill in this field:"
    },
    "primary-column-title_one": "There is only one record \"{{title}}\" in this control card",
    "primary-column-title_other": "There are {{count}} records \"{{title}}\" in this control card",
    "row": {
      "action": {
        "complete": "Lock and continue",
        "complete-error": {
          "message_one": "There is one record that has to be filled in",
          "message_other": "There are {{count}} records that have to be filled in",
          "title": "The control card cannot be completed"
        },
        "complete-success-last-record": "The record was locked successfully and this is the last record in the control card",
        "confirm-delete": {
          "title_one": "Are you sure you want to delete this record?",
          "title_other": "Are you sure you want to delete these {{count}} records?",
          "title-name": "Delete \"{{name}}\"?"
        },
        "confirm-remove-signature": {
          "title": "Are you sure you want to remove this signature?"
        },
        "delete": "Delete",
        "more-info": "Additional information",
        "title": "Actions for this record",
        "uncomplete": "Unlock this record"
      },
      "completed-by": "Locked by",
      "more-info": {
        "title": "Details about this record"
      }
    },
    "status": {
      "completed": "Completed by <Name/>",
      "not-applicable": "Not applicable (marked by {{notApplicableBy}} with reason: {{notApplicableReason}})",
      "not-completed": "Not completed"
    },
    "title": "Control Cards",
    "type": {
      "daily": "Daily",
      "recurring": "Recurring"
    },
    "value": {
      "empty": "No value",
      "invalid": "Invalid value!"
    }
  },
  "error": {
    "playback": {
      "header": "Error during playback of the topic",
      "message": "Please reload the application and try again",
      "reload-button": "Reload"
    },
    "unexpected": {
      "header": "Error",
      "message": "Please reload the application",
      "reload-button": "Reload"
    }
  },
  "g": {
    "action": "Actions",
    "add": "Add",
    "all": "All",
    "app-name": "FSAcademy.bg",
    "attachment": {
      "delete-confirmation": {
        "title": "Are you sure you want to delete this attachment?"
      }
    },
    "back": "Back",
    "back-to-home": "Back to home",
    "cancel": "Cancel",
    "change": "Change",
    "clear": "Clear",
    "close": "Close",
    "combo-box": {
      "add-header": "Add option",
      "delete-title": "Are you sure you want to delete this option?",
      "edit-header": "Edit the option",
      "placeholder": "Type or select from the list"
    },
    "complete": "Complete",
    "continue_zero": "Continue",
    "continue_one": "Continue ({{count}})",
    "continue_other": "Continue ({{count}})",
    "copyright-and-privacy-policy": "© 2026 Ef Es Academy Ltd. ⋅ <2>Privacy Policy</2>",
    "delete": "Delete",
    "discard": "Discard",
    "doc-file-name": "File name",
    "doc-file-size": "Size",
    "edit": "Edit",
    "error": {
      "action-failed": "Error while performing the action",
      "barsy-error": "Barsy error",
      "disabled-error": "Your account is deactivated. Please contact the administrator",
      "network-error": "Temporarily there is no connection with the server. Check your internet connection and try again",
      "not-available-error": "The resource is not available or you do not have access to it.",
      "server-error": "Server error. Please try again shortly"
    },
    "feature-disabled": "This feature is disabled for your company",
    "filter": "Apply filter",
    "filter-button_zero": "Filter",
    "filter-button_one": "Filter ({{count}})",
    "filter-button_other": "Filters ({{count}})",
    "later": "Later",
    "loading": "Loading, please wait...",
    "loading-error": "Unexpected error has occurred. Please try again later.",
    "ok": "OK",
    "page-not-found": "Page Not Found",
    "pagination": {
      "page": "Page {{pageNumber}} of {{pageCount}}"
    },
    "privacy-policy-url": "/legal/privacy-policy/latest-en",
    "remove": "Remove",
    "required": "required",
    "save": "Save",
    "search-employee-name-or-position": "Search by name or position",
    "select-date": "Select date",
    "select-employee": "Select employee",
    "select-time": "Select time",
    "select-value": "Select",
    "server-error": {
      "broadcast": {
        "not-editable": "This message can no longer be edited"
      },
      "client": {
        "name-blank": "The name must not be blank"
      },
      "export": {
        "cards-not-found": "Some of the selected control cards were not found or are not accessible",
        "filter-empty": "No control cards match the selected filter",
        "filter-limit-exceeded": "The filter matches {{matched}} control cards — the maximum for one export is {{max}}",
        "limit-exceeded": "{{selected}} control cards selected — the maximum for one export is {{max}}",
        "must-be-stopped": "The export must be stopped first",
        "no-cards-selected": "No control cards selected for export"
      },
      "level": {
        "no-free-seats": "There are not enough free seats in the selected level",
        "not-empty": "There are still {{occupied}} employees in this level",
        "seats-below-occupied": "The level currently has {{occupied}} employees and cannot be reduced to {{requested}} seats"
      },
      "login": {
        "invalid-credentials": "Invalid credentials"
      },
      "manager": {
        "duplicate-email": "Another user with this email already exists"
      },
      "password": {
        "mismatch": "The passwords do not match",
        "too-short": "The password must be at least {{minLength}} characters"
      },
      "supplier": {
        "duplicate-name": "Another supplier with this name already exists"
      },
      "ticket": {
        "admin-recipient": "Administrators cannot be ticket recipients",
        "last-recipient": "You cannot leave a ticket if you are the only recipient",
        "not-recipient": "You are not a recipient of this ticket"
      }
    },
    "share": {
      "button": "Share",
      "download": {
        "downloading": "Downloading, please wait...",
        "error": {
          "message": "An error occurred while downloading the file. Please try again.",
          "title": "File download error"
        }
      },
      "error": {
        "generic": "Your browser does not support this method of file sharing. Please try the other options.",
        "title": "File sharing error"
      },
      "pdf-file-attach": "Share PDF",
      "pdf-file-download": "Download PDF",
      "title": "Sharing document {{name}}"
    },
    "upload": "Upload",
    "upload-more": "Upload more",
    "uploaded-files_one": "Uploaded files: {{count}}",
    "uploaded-files_other": "Uploaded files: {{count}}",
    "uploading": "Uploading ({{percent}}%)",
    "user-disable": {
      "action": "Log in as another employee",
      "title": "Your access has been deactivated"
    },
    "validation": {
      "access-code-length": "The access code must be 9 digits",
      "date-invalid": "Invalid date",
      "date-required": "The date is required",
      "number-invalid": "Invalid number",
      "phone-length": "The phone number must be exactly 9 digits",
      "required": "Required",
      "time-invalid": "Invalid time",
      "time-required": "The time is required"
    },
    "yes": "Yes"
  },
  "help": {
    "email-action": "{{email}}",
    "email-title": "Contact us via email:",
    "manual-action": "Open the manual",
    "manual-title": "Review the user manual:",
    "p1": "If you are having trouble using the application, you can get help in the following ways:",
    "phone-action": "{{phone}}",
    "phone-title": "Contact us by phone:",
    "title": "Help",
    "viber-action": "Chat in Viber",
    "viber-title": "Send us a message via Viber:",
    "work-hours": "We will respond during working days, from 9 AM to 5 PM"
  },
  "incdoc": {
    "action": {
      "confirm-delete": {
        "title": "Are you sure you want to delete this document?"
      },
      "delete": "Delete",
      "edit": "Edit",
      "scan-result": "View recognized document",
      "title": "Actions"
    },
    "add-doc": "New document",
    "doc": {
      "add-document-success": "Successfully added a document",
      "add-document-title": "Add Document",
      "ai-apply-button": "Fill selected",
      "ai-create-new": "Create new",
      "ai-dialog-title": "Verify the recognized attributes against the document",
      "ai-existing": "Existing",
      "ai-fill-button": "Start",
      "ai-fill-label": "Fill with AI",
      "ai-new": "New",
      "ai-no-results": "We couldn't recognize any data from the documents. Please take a clearer photo—make sure there is enough light and the entire document is visible in the frame.",
      "ai-no-results-label": "No data recognized with AI",
      "ai-suggestions-button": "Review",
      "ai-suggestions-label": "We recognized the document with AI",
      "ai-use-existing": "Use existing",
      "doc-date": "Document Date",
      "doc-num": "Document Number",
      "doc-num-placeholder": "Please enter document number",
      "edit-document-title": "Edit Document",
      "location": "Location",
      "notes": "Notes",
      "notes-placeholder": "Additional notes (if needed)",
      "supplier": "Supplier",
      "update-document-success": "Successfully updated the document"
    },
    "doc-name": "{{number}} dated {{date}}",
    "doc-no": "Document #{{docNum}}",
    "doc-subtitle": "Document date <2><0></0></2>, supplier <4>{{supplierName}}</4>, location <6>{{locationName}}</6>, created by <9>{{creatorName}}</9> at <11><0></0></11>",
    "filter": {
      "created-date-after": "Create Date From",
      "created-date-before": "Create Date Until",
      "doc-date-after": "Document Date From",
      "doc-date-before": "Document Date Until",
      "keyword": "Search",
      "keyword-placeholder": "Document number, supplier, etc.",
      "order": "Order",
      "order-by": {
        "created-at": "Create Date",
        "document-date": "Document Date"
      },
      "title": "Filter Documents"
    },
    "no-documents": "No Documents Found",
    "pagination-count": "{{itemCount}} documents",
    "purchase-doc": {
      "actions-title": "Actions",
      "export-excel": "Export as Excel",
      "invoice-number": "Document #{{num}}",
      "preview-title": "Recognition preview"
    },
    "supplier": {
      "add-supplier-error": "Error adding supplier",
      "add-supplier-success": "Successfully added a supplier",
      "add-title": "Add Supplier",
      "display-with-eik": "{{name}} (EIK {{eik}})",
      "edit-supplier-error": "Error editing supplier",
      "edit-supplier-success": "Successfully edited supplier",
      "edit-title": "Edit Supplier",
      "eik": "EIK",
      "eik-placeholder": "Please enter EIK",
      "name": "Name",
      "name-placeholder": "Please enter the supplier name",
      "notes": "Notes",
      "notes-placeholder": "Additional notes (if needed)"
    },
    "title": "Purchase Records",
    "upload": {
      "error": "Error",
      "finished": "Finished",
      "pending": "Pending",
      "uploading": "Uploading"
    }
  },
  "login": {
    "employee-login": "Employee Login",
    "enter-your-access-code": "Please enter your access code",
    "failed": "Unsuccessful login. Please check if the access code is correct",
    "login-button": "Login",
    "no-access-code": "I don't have an access code",
    "privacy-policy": "By pressing the \"Login\" button, you agree with our <2>privacy policy</2>.",
    "success": "Successful login!",
    "welcome": "Welcome to FSAcademy!"
  },
  "menu": {
    "android-app": "Android App",
    "control-card": "Control Cards",
    "course": "Training Course",
    "help": "Help",
    "incoming-control": "Purchase Records",
    "language": "Language",
    "logged-out": {
      "already-part-of-team": "Already part of the team?",
      "contact-admin-for-code": "Contact your manager for an access code.",
      "contact-us-to": "Contact us to:",
      "email": "Email",
      "fully-digitize": "<0>fully digitize</0> your food safety control.",
      "get-demo": "get a <1>short demo</1> of the platform.",
      "get-to-know-services": "<1>learn</1> about our digital services.",
      "phone": "Phone",
      "want-to-digitize-question": "Do you want to digitize your food safety?"
    },
    "logout": "Logout",
    "new-badge": "New",
    "notifications": "Notifications",
    "organizer": "Organizer",
    "test-mode": "Test mode",
    "tickets": "Tickets"
  },
  "notifications": {
    "marked-all-as-read": "All notifications marked as read",
    "native": {
      "enable-notifications": "Device notifications",
      "permission-hint": "To receive notifications, you must grant permission",
      "title": "Notification Settings"
    },
    "no-notifications": "There are no notifications",
    "read-at": "Read at <ReadAtTime/>",
    "title_zero": "Notifications",
    "title_one": "Notifications ({{count}})",
    "title_other": "Notifications ({{count}})",
    "unread-alert": {
      "header_one": "You have {{count}} unread notification",
      "header_other": "You have {{count}} unread notifications",
      "message_one": "Do you want to read it now?",
      "message_other": "Do you want to read them now?"
    }
  },
  "organizer": {
    "action": {
      "confirm-delete": {
        "title": "Are you sure you want to delete this document?"
      },
      "edit": "Edit"
    },
    "add-document-title": "Add Document",
    "edit-document-title": "Edit Document",
    "folder": {
      "add-new-document": "New Document",
      "add-title": "Add Folder",
      "confirm-delete": {
        "message": "All documents in the folder will be deleted!",
        "title": "Delete {{name}}?"
      },
      "edit": "Edit",
      "edit-title": "Edit Folder",
      "name": "Name",
      "name-placeholder": "Enter folder name",
      "title": "Documents"
    },
    "folder-list": {
      "add": "New Folder",
      "title": "Folders"
    },
    "form": {
      "folder": "Folder",
      "folder-required": "Select a folder",
      "name": "Name",
      "name-placeholder": "Enter document name",
      "name-required": "The name is required",
      "notes": "Notes",
      "notes-placeholder": "Additional notes (if needed)",
      "notify-before-expiry": "Send me a reminder",
      "notify-before-expiry-hint-1": "We will send a notification before the document expires.",
      "notify-before-expiry-hint-2": "Select \"Expires on\" to add a reminder.",
      "notify-before-expiry-placeholder": "No reminder",
      "notify-before-expiry-unit": "days earlier",
      "state": "State",
      "valid-from": "Issue Date",
      "valid-from-hint": "Do not fill in if there is no issue date",
      "valid-until": "Expires on",
      "valid-until-hint": "Do not fill in if there is no expiration date",
      "valid-until-quick-hint": "Quick expiration",
      "valid-until-quick-hint-1-month": "1 month",
      "valid-until-quick-hint-1-year": "1 year",
      "valid-until-quick-hint-2-years": "2 years",
      "valid-until-quick-hint-3-months": "3 months",
      "valid-until-quick-hint-6-months": "6 months"
    },
    "location": "Location",
    "never-expires": "No expiration",
    "no-locations": "You don't have access to the organizer in any location",
    "no-reminder-label": "No reminder",
    "notify-before-expiry-label": "Reminder <ReminderDuration/> earlier",
    "state": {
      "complete": "Completed",
      "pending": "Pending"
    },
    "title": "Organizer",
    "valid-from": "Valid from <2><0></0></2> <4></4>",
    "valid-from-until": "Valid from <2><0></0></2> until <6><0></0></6>",
    "valid-until": "Valid until <2><0></0></2> ",
    "validity": {
      "expired": "Expired",
      "expires-soon": "Expires soon"
    }
  },
  "player": {
    "lesson-duration": "{{minutes}} minutes",
    "modal": {
      "again": {
        "header": "This topic has finished",
        "sub-header": "Select one of the following options",
        "watch-again": "Watch again"
      },
      "current": {
        "continue-button": "Continue",
        "continue-header": "Press to continue",
        "ended-header": "This topic has finished",
        "go-to-test": "Go to the test"
      },
      "segment": {
        "back-to-home": "Back to home",
        "back-to-results": "Back to results",
        "header": "This segment should have given the necessary information to answer the question",
        "sub-header": "Select one of the following options",
        "watch-again": "Watch again"
      }
    },
    "remaining-time-minutes": "{{minutes}} minutes remaining.",
    "remaining-time-seconds": "{{seconds}} seconds remaining.",
    "watch-lesson": "Play now"
  },
  "purchase-doc": {
    "disclaimer": "Discrepancies are possible — compare with the original documents.",
    "field": {
      "address": "Address",
      "eik": "EIK",
      "expiration-date": "Expiration date",
      "item-number": "Code",
      "lot-number": "Lot",
      "mol": "MOL",
      "name": "Name",
      "quantity": "Quantity",
      "quantity-short": "Qty",
      "total-price": "Amount",
      "unit": "Unit",
      "unit-price": "Unit price",
      "unit-price-short": "Unit price",
      "unit-short": "Unit"
    },
    "party": {
      "buyer": "Buyer",
      "supplier": "Seller"
    },
    "print-title": "Document #{{number}}",
    "products": "Products",
    "totals": {
      "base": "Base",
      "total": "Total",
      "vat": "VAT"
    }
  },
  "syllabus": {
    "completed": {
      "completed-at": "Completed at <2><0></0></2> with average score <5>{{scorePercent}}</5>",
      "completed-course": "Congratulations! You have completed this course.",
      "no-completed": "There are no completed courses.",
      "no-such-topic": "There is no such topic",
      "sign-button": "Sign completion",
      "sign-button-again": "Sign again",
      "title": "Completed Courses"
    },
    "in-progress": {
      "course-progress": "There are {{completedLessonsCount}} completed topics out of {{totalLessonsCount}} ({{progressPercent}}) with average score {{averageScorePercent}}",
      "current-test-progress": "Current test result is {{currentScorePercent}}, you need at least {{minScorePercent}} to pass the test.",
      "days-remaining": "{{days}} days until the deadline",
      "from-induction-course": "From the induction course",
      "from-refresh-course": "From the refresher course",
      "induction-course": "Induction Course",
      "last-answered-at": "Last answered at <1></1>",
      "no-in-progress-topic": "There is no in-progress topic",
      "overdue": "{{days}} days overdue!",
      "refresh-course": "Refresher Course",
      "test-progress": "The test is not completed. There are {{totalEmployeeAnswers}} out of {{totalCorrectAnswers}} answers.",
      "there-is-important-question": "There is an important question which is answered incorrectly.",
      "title": "Current Topic"
    },
    "pending": {
      "locked": "This topic is not accessible yet. There is an in-progress topic which is not completed.",
      "no-pending-course": "There is no current course.",
      "title": "Current Course"
    },
    "term-signature": {
      "title": "Sign the completion of the course"
    },
    "topic": {
      "completed-at": "Completed at <1></1> with {{scorePercent}} score.",
      "started-at": "Started at <1></1>."
    }
  },
  "test": {
    "cant-view-test": "The test will be available after you watch the whole topic.",
    "cant-view-test-result": "The test result will be available after you complete the test.",
    "check-the-answer-in-segment": "Watch that part of the topic again",
    "complete-test": "Complete",
    "congrats": "Congratulations!",
    "continue-to-next": "Continue to next topic",
    "correct-answer": "Correct answer",
    "failed-answers-paragraph": "There are {{questionsCount}} incorrect answers to the following questions:",
    "next-question": "Next",
    "no-answer": "There is no answer",
    "no-test-message": "There is no test for this topic.",
    "not-sufficient-title": "It is not enough to continue to the next topic.",
    "prev-question": "Previous",
    "question-no": "Question {{questionNo}}",
    "refresh-the-answer-in-segment": "Watch that part of the topic again",
    "result-title": "Test Result",
    "success-rate": "You have successfully completed the test with {{currentScorePercent}}% score",
    "take-test": "Complete the test",
    "take-test-again": "Answer the incorrect questions again",
    "take-test-again-hint": "You must watch the part of the topic again before answering the question.",
    "title": "Test your knowledge",
    "view-results": "View the test results",
    "wrong-questions-title": "You have {{questionsCount}} incorrect answers, here are the correct answers:",
    "your-answer": "Your answer",
    "your-result-is": "Your score is {{currentScorePercent}}%"
  },
  "ticket": {
    "action": {
      "accept": "Accept",
      "done": "Complete",
      "print": "Print",
      "todo": "To do"
    },
    "add": {
      "content": "Description",
      "content-placeholder": "Add details that would help resolve the ticket",
      "group-employees": "Employees",
      "group-managers": "Managers",
      "location": "For locations",
      "location-placeholder": "Which locations does the ticket apply to, if applicable",
      "recipients-label": "Recipients",
      "recipients-required": "Please select at least one recipient",
      "recipients-search-placeholder": "Search by name, position, or location",
      "subject": "Subject",
      "subject-placeholder": "What is the ticket about",
      "submit": "Create",
      "title": "New ticket"
    },
    "change-status": "Change status",
    "create-from-cc": "Submit a ticket",
    "delete": {
      "confirm-message": "Are you sure you want to delete this ticket?",
      "confirm-title": "Delete ticket"
    },
    "detail": {
      "control-card": "<Name/> from <Date/>",
      "message-placeholder": "Write a message...",
      "refreshed": "The ticket has been updated",
      "status-changed": "<Name/> changed the status to <Status/>",
      "title": "Ticket"
    },
    "edit": {
      "submit": "Save"
    },
    "filter": {
      "location": "For locations",
      "no-location": "No location",
      "status": "Status",
      "text": "Search",
      "text-placeholder": "Search tickets...",
      "title": "Filter"
    },
    "new": "New ticket",
    "no-tickets": "No tickets found",
    "pagination-count": "{{itemCount}} tickets",
    "status": {
      "DONE": "Completed",
      "IN_PROGRESS": "In progress",
      "TODO": "To do"
    },
    "tab": {
      "for-me": "For me",
      "from-me": "From me"
    },
    "title": "Tickets"
  }
}
